module.exports = __webpack_public_path__ + "assets/media/day40.03c6a6a9.mp3";